import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import reportWebVitals from './reportWebVitals';
import NiceModal from '@ebay/nice-modal-react';
import { ToastProvider } from './components/toasts/Toast';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <NiceModal.Provider>
    <ToastProvider>
      {/* <Provider store={store}> */}
        <App />
      {/* </Provider> */}
    </ToastProvider>
  </NiceModal.Provider>
  // <React.StrictMode>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
